import {
  LVR_AMBER_THRESHOLD,
  LVR_RED_THRESHOLD,
} from '../config/constants';
import type { CalculationSettings } from '../config/calculationSettings';
import type { Status } from '../types';

export function computeStatus(
  surplus: number,
  lvr: number,
  settings: CalculationSettings,
): Status {
  if (surplus < 0 || lvr > LVR_RED_THRESHOLD) return 'red';
  if (lvr > LVR_AMBER_THRESHOLD || surplus < settings.surplusAmberThreshold)
    return 'amber';
  return 'green';
}
